export const getVisibleFields = <T extends string>(fields: T[], disabledFields: string[] = []) =>
  disabledFields.length === 0 ? fields : fields.filter((item) => !disabledFields.includes(item));

export const getColumnWidths = <T extends string>(fields: T[], getFieldWidth: (field: T) => number, autoField: T) => {
  const minFieldWidth = Math.floor(100 / fields.reduce((acc, field) => acc + getFieldWidth(field), 0));
  return fields.map((field) => (field === autoField ? 'auto' : `${minFieldWidth * getFieldWidth(field)}%`));
};

export const getColumnAlignments = <T extends string>(
  fields: T[],
  columnAlignment: Partial<Record<T, 'left' | 'right'>>,
  defaultAlignment: 'left' | 'right' = 'left',
) => fields.map((field) => columnAlignment[field] ?? defaultAlignment);
